import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import DevicesTable from './devicesTable';
import constant from '../../constant';

const DevicesContent = () => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { hospitalId } = useParams();

  useEffect(() => {
    const fetchDevices = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${constant.REACT_APP_API_URL}/hospital/${hospitalId}/devices`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();
        if (response.ok) {
          setDevices(result.map(device => ({
            device_id: device.device_id,
            device_name: device.device_name,
            hospital_id: device.hospital_id,
            hospital_name: device.hospital_name,
            is_active: device.is_active,
            created_by: device.created_by || 'system',
            created_on: device.created_on,
          })));
        } else {
          setError(result.message || 'Failed to fetch devices');
        }
      } catch (error) {
        setError('Error fetching devices');
      } finally {
        setLoading(false);
      }
    };

    fetchDevices();
  }, []);

  const handleDelete = async (id) => {
    const token = localStorage.getItem('token');
    if (!token) {
      setError('No authentication token found');
      return;
    }

    try {
      const response = await fetch(`${constant.REACT_APP_API_URL}/device/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      if (response.ok) {
        setDevices(devices.filter((device) => device.device_id !== id));
      } else {
        setError(result.message || 'Failed to delete device');
      }
    } catch (error) {
      setError('Error deleting device');
    }
  };

  const handleEdit = (updatedDevice) => {
    setDevices(devices.map((device) =>
      device.device_id === updatedDevice.device_id ? updatedDevice : device
    ));
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-6 text-red-600">
        {error}
        <button
          onClick={() => setError(null)}
          className="ml-4 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
        >
          Clear Error
        </button>
      </div>
    );
  }

  return (
    <div className="px-6 pt-4 md:pt-0">
      <div className="">
        <DevicesTable
          toAdd={true}
          parent={false}
          devices={devices}
          onDelete={handleDelete}
          onEdit={handleEdit}
        />
      </div>
    </div>
  );
};

export default DevicesContent;